// extracted by mini-css-extract-plugin
export default {"whoAreWeSection":"WhoAreWe_whoAreWeSection__Bgwiu","whoAreWe":"WhoAreWe_whoAreWe__r08bD"};